import { LeadEnrollmentStatusFilter } from './lead-enrollment-status-filter';
import { LeadProgramFilter } from './lead-program-filter';
import { LeadStatusFilter } from './lead-status-filter';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { Button } from '@src/design-system/button';
import { AddSquare } from 'iconsax-react';
import { DynamicCustomFieldFilterRow } from '@src/shared/features/views/components/filter-popover-content/dynamic-custom-fields/dynamic-custom-field-filter-row';

import type { TCustomFieldFilter } from '@shared/types/custom-field-filter';
import { LeadReferalFilter } from './lead-referal-filter';

import { LeadCalendlyTypeFilter } from './lead-calendly-type-filter';
import { LeadEnglishLevelFilter } from './lead-english-level';
import { LeadGenderFilter } from './lead-gender-filter';
import { LeadRankFilter } from './lead-rank-filter';
import { LeadAssigneeFilter } from './lead-assignee-filter';
import { LeadDuplicatesFilter } from './lead-duplicates-filter';
import { LeadIncludeFilter } from './lead-include-filter';
import { LeadLabelsFilter } from './lead-labels-filter';

import {
  Popover,
  PopoverAnchor,
  PopoverContent,
} from '@src/design-system/popover';
import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { leadScreeningMeetingDateFilterConfig } from '../../../configs/lead-screening-meeting-date-filter-config';
import { createdAtFilterConfig } from '../../../configs/created-at-filter-config';
import { leadUpdatedAtFilterConfig } from '../../../configs/lead-updated-at-filter-config';
import { birthDateFilterConfig } from '../../../configs/birth-date-filter-config';
import { leadNextFollowUpDateFilterConfig } from '../../../configs/lead-next-follow-up-date-filter-config';
import { useTableStates } from '@src/design-system/molecules/ticlick-table/hooks/use-table-states';

export function LeadFilters() {
  const { addCustomFieldFilter } = useTableViewHelpers();
  const { tableFilters } = useTableStates();

  const customFilters = tableFilters?.customFieldFilters || [];

  // const customFieldFiltersCount = customFilters.length;
  // const createdCustomFieldFiltersCount = currentView?.custom_filters.length;

  // const addFilterRowIfNoFilters = () => {
  //   if (customFieldFiltersCount) return;
  //   addCustomFieldFilter({} as TCustomFieldFilter);
  // };

  return (
    <Popover modal>
      <PopoverAnchor>
        <div className='flex flex-col gap-4'>
          {/* <PopoverTrigger asChild>
            <Button
              onClick={addFilterRowIfNoFilters}
              size='sm'
              className='text-[13px] bg-primary-50 [&_svg]:size-4 text-primary-900 border border-dashed border-primary-200 hover:bg-primary-100/70'
            >
              <AddSquare />
              Add filter
              {!!createdCustomFieldFiltersCount && (
                <Badge className='rounded-full text-[10px] flex justify-center items-center size-4 p-1 font-medium bg-primary-900 text-white'>
                  {createdCustomFieldFiltersCount}
                </Badge>
              )}
            </Button>
          </PopoverTrigger> */}

          {/* <Separator /> */}

          <LeadIncludeFilter />

          <LeadGenderFilter />

          <LeadRankFilter />

          <LeadCalendlyTypeFilter />

          <LeadDuplicatesFilter />

          <LeadProgramFilter />

          <LeadEnrollmentStatusFilter />

          <LeadAssigneeFilter />

          <LeadReferalFilter />

          <LeadStatusFilter />

          <LeadLabelsFilter />

          <LeadEnglishLevelFilter />

          <InputFilterTrigger
            filterLabel='Screening Meeting Date'
            config={leadScreeningMeetingDateFilterConfig}
          />

          <InputFilterTrigger
            filterLabel='Created At'
            config={{ ...createdAtFilterConfig, withNoneOption: false }}
          />

          <InputFilterTrigger
            filterLabel='Updated At'
            config={leadUpdatedAtFilterConfig}
          />

          <InputFilterTrigger
            filterLabel='Birth Date'
            config={birthDateFilterConfig}
          />

          <InputFilterTrigger
            filterLabel='Next Follow Up Date'
            config={leadNextFollowUpDateFilterConfig}
          />
        </div>
      </PopoverAnchor>

      <PopoverContent
        align='end'
        className='absolute top-[-13px] w-fit left-6 space-y-2'
      >
        {customFilters.map((f, index) => {
          return (
            <DynamicCustomFieldFilterRow
              key={f.id}
              dynamicFilter={f}
              position={index}
            />
          );
        })}
        <Button
          size='sm'
          onClick={() => addCustomFieldFilter({} as TCustomFieldFilter)}
          className='text-[13px] bg-primary-50 [&_svg]:size-4 text-primary-900 border border-dashed border-primary-200 hover:bg-primary-100/70'
        >
          <AddSquare />
        </Button>
      </PopoverContent>
    </Popover>
  );
}
